function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9225 0 0 1.9225 -3218.3 -55.752)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1674,29)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.645,
  cy: 16.645,
  r: 16.645,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.645,
  cy: 16.645,
  r: 15.145,
  fill: "none"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(1685.6 53.29)",
  fill: "currentColor",
  fontFamily: "BloggerSans-Bold, 'Blogger Sans'",
  fontSize: "22px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "?")));
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.5f44f92a.svg";
export { ForwardRef as ReactComponent };